import { authHeader, handleResponse } from "..";

export type ReferenceDeletedRestoreAvailableConflict = {
    code: string;
    message: string;
    existingId: string;
    existingCode: string;
};

export function isReferenceDeletedRestoreAvailableConflict(
    value: unknown,
    expectedCode: string
): value is ReferenceDeletedRestoreAvailableConflict {
    return (
        typeof value === "object" &&
        value !== null &&
        (value as ReferenceDeletedRestoreAvailableConflict).code === expectedCode &&
        typeof (value as ReferenceDeletedRestoreAvailableConflict).existingId === "string"
    );
}

export class ReferenceCreateConflictError extends Error {
    readonly conflict: ReferenceDeletedRestoreAvailableConflict;

    constructor(conflict: ReferenceDeletedRestoreAvailableConflict) {
        super(conflict.message);
        this.name = "ReferenceCreateConflictError";
        this.conflict = conflict;
    }
}

export type ReferenceRestoreDeletedPayload = {
    id: string;
    description: string;
    isActive?: boolean;
};

/** POST create; throws ReferenceCreateConflictError on structured 409 restore-available. */
export async function postReferenceCreate<TDetail>(
    createUrl: string,
    payload: unknown,
    deletedRestoreAvailableCode: string
): Promise<TDetail> {
    const response = await fetch(createUrl, {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
        body: JSON.stringify(payload),
    });
    const text = await response.text();
    let data: unknown = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        /* non-JSON */
    }

    if (
        response.status === 409 &&
        isReferenceDeletedRestoreAvailableConflict(data, deletedRestoreAvailableCode)
    ) {
        throw new ReferenceCreateConflictError(data);
    }

    return handleResponse({
        text: async () => text,
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
    }) as Promise<TDetail>;
}
